export enum WireComponentKind {
    // shared
    TextField = "text-field",
    NumberField = "number-field",
    EmailField = "email-field",
    PhoneField = "phone-field",
    DateTimeField = "date-field",
    FilePicker = "file-picker",
    ImagePicker = "image-picker",
    Toggle = "toggle",

    // pages
    Button = "page-button",
    Hint = "page-hint",
    Hero = "hero",
    ContactForm = "contact-form",
    DynamicButtonBar = "dynamic-button-bar",
    List = "list",
    Container = "container",
    FormContainer = "form-container",
    Fields = "fields",
    BigNumbers = "big-numbers",
    Breadcrumbs = "breadcrumbs",
    RichText = "page-rich-text",
    Image = "page-image",
    Video = "page-video",
    Separator = "page-separator",
    SignIn = "sign-in",
    Custom = "custom",

    // apps
    AppButton = "app-button",
    AppButtonBar = "app-button-bar",
    AppTitle = "app-title",
    AppAdaptiveListItem = "app-adaptive-list-item",
    AppImage = "app-image",
    AppSeparator = "app-separator",
    AppTextBox = "app-text-box",
    AppPhoneNumber = "app-phone-number",
    AppSimpleTable = "app-simple-table",
    AppHint = "app-hint",
    AppMarkdown = "app-markdown",
    AppAudioPlayer = "app-audio-player",
    AppVideoPlayer = "app-video-player",
    AppProgress = "app-progress",
    AppLike = "app-like",
    AppRating = "app-rating",
    AppReaction = "app-reaction",
    AppTinder = "app-tinder",
}
